import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AmplifyService} from 'aws-amplify-angular';

import {AppComponent} from './app.component';
import {HeaderComponent} from './header/header.component';
import {LanguageSelectorComponent} from './language-selector/language-selector.component';
import {LanguageService} from './shared/language.service';
import {HomeComponent} from './home/home.component';
import {ContactComponent} from './contact/contact.component';
import {DogsComponent} from './dogs/dogs.component';
import {AppRoutingModule} from './app-routing.module';
import {NewsComponent} from './news/news.component';
import {DogService} from './shared/dog.service';
import {DogListComponent} from './dog-list/dog-list.component';
import {DogDetailsComponent} from './dog-details/dog-details.component';
import {LittersComponent} from './litters/litters.component';
import {LitterService} from './shared/litters.service';
import { LinksComponent } from './links/links.component';
import { DogPedigreeComponent } from './dog-pedigree/dog-pedigree.component';
import { PhotoComponent } from './photo/photo.component';
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LanguageSelectorComponent,
    HomeComponent,
    ContactComponent,
    DogsComponent,
    NewsComponent,
    DogListComponent,
    DogDetailsComponent,
    LittersComponent,
    LinksComponent,
    DogPedigreeComponent,
    PhotoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [AmplifyService, LanguageService, DogService, LitterService],
  bootstrap: [AppComponent]
})
export class AppModule {
}
